import React, { useState } from 'react';

import styled from 'styled-components';

import { ActivityActions } from '../../infrastructure/constants/activities';

import ItemActionsContainer from './ItemActionsContainer';

const StyledActionsButton = styled.button`
  display: inline-block;
  position: relative;
  margin-left: 20px;
  width: 32px;
  height: 32px;
  color: #cccccc;
  border: 1px solid #cccccc;
  border-radius: 50%;
  cursor: pointer;
  padding-top: 20px;
  outline: none;
  background: none;

  &:before {
    content: '\\2022 \\2022 \\2022';
    position: absolute;
    top: 7px;
    left: 3px;
    font-size: 15px;
    letter-spacing: 4px;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

type Props = {
  actions: ActivityActions[];
  setCopyAlert: (str: string) => void;
};

const ItemActions = ({ actions, setCopyAlert }: Props) => {
  const [isActionsOpen, setIsActionsOpen] = useState(false);
  return (
    <StyledActionsButton
      type='button'
      onClick={() => setIsActionsOpen(prev => !prev)}
    >
      {isActionsOpen && (
        <ItemActionsContainer
          actions={actions}
          closeActions={() => setIsActionsOpen(false)}
          setCopyAlert={setCopyAlert}
        />
      )}
    </StyledActionsButton>
  );
};

export default React.memo(ItemActions);
